import { render, staticRenderFns } from "./ChecklistDropdownFieldModule.vue?vue&type=template&id=0b2f49f2&scoped=true"
import script from "./ChecklistDropdownFieldModule.vue?vue&type=script&lang=ts"
export * from "./ChecklistDropdownFieldModule.vue?vue&type=script&lang=ts"
import style0 from "./ChecklistDropdownFieldModule.vue?vue&type=style&index=0&id=0b2f49f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2f49f2",
  null
  
)

export default component.exports